import Image from 'next/image';
// import {
//   IoBagRemoveOutline,
//   IoBusinessOutline,
//   IoNewspaperOutline,
//   IoRibbonOutline,
//   IoShareSocialOutline,
// } from 'react-icons/io5';
import { ReactNode } from 'react';
// import { AiOutlineUser } from 'react-icons/ai';
// import { RiContactsLine } from 'react-icons/ri';
// import { MdWebAsset } from 'react-icons/md';
import {
  UserSettingEnum,
  UserSettingType,
} from '../interfaces/profile.interface';
// import { FiFileText } from 'react-icons/fi';
export const detechBuildProfileKey = (key: string) => {
  if (
    key == 'school' ||
    key == 'experience' ||
    key == 'reward' ||
    key == 'scientific' ||
    key == 'avatar' ||
    key == 'bio' ||
    key == 'contact' ||
    key == 'certificate'
  )
    return true;
  return false;
};

const buildProfileInfo = (
  title: string,
  description: string,
  icon: ReactNode
) => {
  return {
    title,
    description,
    icon,
  };
};

export const detectUserSettingEnum = (
  key: string
): UserSettingType | undefined => {
  switch (key) {
    case UserSettingEnum.Experience: {
      return UserSettingEnum.Experience;
    }
    case UserSettingEnum.Introduction: {
      return UserSettingEnum.Introduction;
    }
    case UserSettingEnum.School: {
      return UserSettingEnum.School;
    }
    case UserSettingEnum.Scientific: {
      return UserSettingEnum.Scientific;
    }
    case UserSettingEnum.SocialLink: {
      return UserSettingEnum.SocialLink;
    }
    case UserSettingEnum.Award: {
      return UserSettingEnum.Award;
    }
    case UserSettingEnum.Website: {
      return UserSettingEnum.Website;
    }
    case UserSettingEnum.Contact: {
      return UserSettingEnum.Contact;
    }
    case UserSettingEnum.Certificate: {
      return UserSettingEnum.Certificate;
    }
    case UserSettingEnum.Fullname: {
      return UserSettingEnum.Fullname;
    }
    case UserSettingEnum.Avatar: {
      return UserSettingEnum.Avatar;
    }
  }
};

export const parseBuildProfile = (key: string) => {
  switch (key) {
    case 'avatar': {
      return buildProfileInfo(
        'Ảnh đại diện chuyên nghiệp của bạn',
        'Giúp đồng nghiệp nhận ra bạn qua hình ảnh chuyên nghiệp.',
        <div className="text-primary text-2xl mx-4 mt-1.5 flex justify-center items-center">
          <Image
            src={'/icons/user.svg'}
            alt="avatar icon"
            width={36}
            height={36}
          />
        </div>
      );
    }
    case 'bio': {
      return buildProfileInfo(
        'Giới thiệu bản thân bạn',
        'Mô tả ngắn giúp người khác hiểu hơn về bạn',
        <div className="text-primary text-2xl mx-4 mt-1.5 flex justify-center items-center">
          <Image
            src={'/icons/document.svg'}
            alt="biography icon"
            width={36}
            height={36}
          />
        </div>
      );
    }
    case 'school': {
      return buildProfileInfo(
        'Bạn học trường nào?',
        'Cập nhật quá trình học vấn của bạn',
        <div className="text-primary text-2xl mx-4 mt-1.5 flex justify-center items-center">
          <Image
            src={'/icons/education.svg'}
            alt="school icon"
            width={36}
            height={36}
          />
        </div>
      );
    }
    case 'experience': {
      return buildProfileInfo(
        'Bạn công tác tại đâu?',
        'Kinh nghiệm làm việc & các hoạt động chuyên môn của bạn',
        <div className="text-primary text-2xl mx-4 mt-1.5 flex justify-center items-center">
          <Image
            src={'/icons/briefcase.svg'}
            alt="experience icon"
            width={36}
            height={36}
          />
        </div>
      );
    }
    case 'certificate': {
      return buildProfileInfo(
        'Chứng nhận bạn đã đạt được ',
        'Chứng nhận về quá trình học tập & các kĩ năng liên quan',
        <div className="text-primary text-2xl mx-4 mt-1.5 flex justify-center items-center">
          <Image
            src={'/icons/certificate.svg'}
            alt="certificate icon"
            width={36}
            height={36}
          />
        </div>
      );
    }
    case 'reward': {
      return buildProfileInfo(
        'Giải thưởng bạn đã đạt được',
        'Giúp mọi người hiểu hơn về thành tích & nỗ lực của bạn',
        <div className="text-primary text-2xl mx-4 mt-1.5 flex justify-center items-center">
          <Image
            src={'/icons/reward.svg'}
            alt="reward icon"
            width={36}
            height={36}
          />
        </div>
      );
    }
    case 'scientific': {
      return buildProfileInfo(
        'Công trình nghiên cứu bạn đã thực hiện',
        'Cảm ơn bạn đã góp phần phát triển nền y học Việt Nam',
        <div className="text-primary text-2xl mx-4 mt-1.5 flex justify-center items-center">
          <Image
            src={'/icons/paper.svg'}
            alt="scientific icon"
            width={36}
            height={36}
          />
        </div>
      );
    }
    case 'social-link': {
      return buildProfileInfo(
        'Mạng xã hội bạn đang dùng',
        'Giúp mọi người kết nối với bạn đa nền tảng',
        <div className="text-primary text-2xl mx-4 mt-1.5 flex justify-center items-center">
          <Image
            src={'/icons/social-media.svg'}
            alt="social media icon"
            width={36}
            height={36}
          />
        </div>
      );
    }
    case 'website': {
      return buildProfileInfo(
        'Website cá nhân của bạn',
        'Giới thiệu thương hiệu bản thân qua website cá nhân',
        <div className="text-primary text-2xl mx-4 mt-1.5 flex justify-center items-center">
          <Image
            src={'/icons/globe.svg'}
            alt="website icon"
            width={36}
            height={36}
          />
        </div>
      );
    }
    case 'contact': {
      return buildProfileInfo(
        'Số điện thoại & email công việc',
        'Bạn có thể ẩn thông tin này để tránh bị làm phiền',
        <div className="text-primary text-2xl mx-4 mt-1.5 flex justify-center items-center">
          <Image
            src={'/icons/contact.svg'}
            alt="contact icon"
            width={36}
            height={36}
          />
        </div>
      );
    }
    default: {
      return buildProfileInfo('', '', null);
    }
  }
};
